import useRouter from './useRouter';
import { PageType, useCurrentPageType } from 'Client/hooks/UrlManager/pageTypeHooks';

export enum HeaderModeType {
    DEFAULT = 'default',
    MINI = 'mini',
    NONE = 'none',
}

export enum FooterModeType {
    DEFAULT = 'default',
    CART = 'cart',
    NONE = 'none',
}

type UseLayoutByPage = () => {
    headerMode: HeaderModeType;
    footerMode: FooterModeType;
};

export const useLayoutByPage: UseLayoutByPage = () => {
    const { pageType } = useCurrentPageType();
    const { isAppWebviewPage } = useRouter();

    if (isAppWebviewPage || pageType === PageType.CHECKOUT) {
        return {
            headerMode: HeaderModeType.NONE,
            footerMode: FooterModeType.NONE,
        };
    }

    if (pageType === PageType.CART) {
        return {
            headerMode: HeaderModeType.MINI,
            footerMode: FooterModeType.CART,
        };
    }

    return {
        headerMode: HeaderModeType.DEFAULT,
        footerMode: FooterModeType.DEFAULT,
    };
};
